import { computed } from 'vue';
import { useUserStore } from '@/store/userStore';
import { useWhatsNewStore } from '@/store/whatsNewStore';
import { useWhatsNewEntries } from '@/composables/queries/useWhatsNewEntries';
import { WHATS_NEW_MENU_COUNT, unseenEntryIds } from '@/utils/whatsNew';

/**
 * What's new for the signed-in user: the entries, which of them are new to
 * this user, and the drawer controls shared by the sidebar menu and the drawer.
 */
export function useWhatsNew() {
  const userStore = useUserStore();
  const store = useWhatsNewStore();
  const { entries, loading, error } = useWhatsNewEntries();

  const userId = computed(() => (userStore.currentUser?.id ? String(userStore.currentUser.id) : null));
  const unseenIds = computed(() => unseenEntryIds(entries.value, store.seenFor(userId.value)));

  /** Remember the newest entry as seen, so the dot goes until the next release. */
  const markAllSeen = () => {
    const newest = entries.value[0];
    if (newest && userId.value) store.markSeen(userId.value, newest.id);
  };

  return {
    entries,
    menuEntries: computed(() => entries.value.slice(0, WHATS_NEW_MENU_COUNT)),
    selectedEntry: computed(() => entries.value.find((entry) => entry.id === store.selectedId) ?? null),
    unseenIds,
    hasUnseen: computed(() => unseenIds.value.length > 0),
    markAllSeen,
    loading,
    error,
    store,
  };
}
